/**
 * Through logging, we have found that structuredClone is still not available in some of our guests browsers, so we've added a zero dependencies polyfill.
 * This can be reviewed and removed if structuredClone is available in all browsers we support.
 */
if (typeof window.structuredClone !== 'function') {
  window.structuredClone = function <T>(obj: T) {
    return JSON.parse(JSON.stringify(obj));
  };
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any)._structuredClonePolyfilledR$ = true;
  } catch {
    /* continue */
  }
}
